import { render, staticRenderFns } from "./SingleVariant.vue?vue&type=template&id=184db378&"
import script from "./SingleVariant.vue?vue&type=script&lang=js&"
export * from "./SingleVariant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports